"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var withOnClickOutside = function withOnClickOutside(WrappedComponent) {
  var OnClickOutside = function OnClickOutside(props) {
    var ref = (0, _react.useRef)();
    var handleClickOutside = props.handleClickOutside;
    var handleMouseDown = function handleMouseDown(e) {
      // eslint-disable-next-line react/no-find-dom-node
      var node = (0, _reactDom.findDOMNode)(ref.current);
      if (node && node.contains(e.target)) {
        return;
      }
      if (typeof handleClickOutside === 'function') {
        handleClickOutside(e);
      }
    };
    (0, _react.useEffect)(function () {
      document.addEventListener('mousedown', handleMouseDown);
      return function () {
        document.removeEventListener('mousedown', handleMouseDown);
      };
    }, []);
    return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({
      ref: ref
    }, props));
  };
  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  OnClickOutside.displayName = "OnClickOutside(".concat(componentName, ")");
  OnClickOutside.propTypes = {
    handleClickOutside: _propTypes.default.func
  };
  return OnClickOutside;
};
var _default = withOnClickOutside;
exports.default = _default;